import actionTypes from '../constants/actionTypes'

export default function fixturesReducer( state = {}, action ) {
  switch(action.type) {

    case actionTypes.GET_FIXTURES:
    
      return Object.assign( {}, state, {
        ...action.data
      })
      
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ../app/reducers/schedule.js
 **/